import { Fetch } from 'lib/Fetch';

export function userInvestmentsService(investmentState) {
  return new Fetch()
    .url(`/user/characteristic-client/info-investments?investmentState=${investmentState}`)
    .method('get')
    .userToken()
    .send();
}

export function userBondCertificate(projectId, bondId) {
  return new Fetch()
    .url(`/user/characteristic-client/bond-certificate/${projectId}/${bondId}`)
    .method('get')
    .userToken()
    .send();
}

export function userPaymentPlan({ projectId }) {
  return new Fetch('api_2')
    .url(`/user/characteristic-client/excel-user-payment-plan/${projectId}`)
    .method('get')
    .userToken()
    .send();
}
